import PrintProductSizeSuccessModal from './PrintProductSizeSuccessModal';

export default PrintProductSizeSuccessModal;
